import React from 'react'
import { string, bool, shape } from 'prop-types'
import styled from 'styled-components'
import { Flex, Box, Image, Heading } from 'rebass'
import { media } from '../../utils/style'
import citygateTheme from '../../theme/'
import typography from '../../utils/typography'

const RightAlignImage = styled(Image)`
  float: right;
  align-self: flex-start;
`
const FlexWrapper = styled(Flex)`
  position: relative;
  min-height: 60vh;
  text-align: center;
  ${media.MediumScreenUp`
  text-align: left;
  `};
`
const ImageBox = styled(({ theme, top, ...rest }) => <Box {...rest} />)`
  ${(props) => (props.top ? 'align-self: flex-start;' : '')}
`

class ContentBannerSignPost extends React.PureComponent {
  render() {
    return (
      <FlexWrapper
        flexWrap="wrap"
        alignItems={['flex-start', 'center']}
        pb={10}
        bg={citygateTheme.colors.blue}
      >
        <Box
          order={[2, 1]}
          width={[12 / 12, 6 / 12]}
          pt={[25, 50]}
          pb={80}
          pl={'8%'}
          pr={['8%', null, 0]}
          color="white"
        >
          <Heading fontSize={[7, 8]} color="white" mb={typography.rhythm(0.5)}>
            {this.props.title}
          </Heading>
          {this.props.children}
        </Box>
        <ImageBox
          order={[1, 2]}
          width={[12 / 12, 6 / 12]}
          top={this.props.img.top}
        >
          <RightAlignImage
            pl={'8%'}
            mb={[0, 70]}
            src={this.props.img.x1}
            srcSet={`${this.props.img.x2} 2x`}
            alt={this.props.alt || this.props.title}
          />
        </ImageBox>
      </FlexWrapper>
    )
  }
}

ContentBannerSignPost.defaultProps = {
  title: 'no title',
  img: { x1: '', x2: '', alt: '', top: false },
  top: false
}
ContentBannerSignPost.propTypes = {
  title: string,
  img: shape({ x1: string, x2: string, alt: string, top: bool })
}

export default ContentBannerSignPost
